import React, {
  useCallback,
  useEffect,
  useState,
} from "react";
import "../screenstyles/Account.css"; // استدعاء الأنماط
import { useNavigate } from "react-router-dom";
import { usersApi } from "../api/usersApi";
import { ApiError } from "../api/apiError";
import {
  provincesApi,
} from "../api/provincesApi";

import type {
  ProvinceRecord,
} from "../types/provinces.types";
import type {
  UserAddress,
  UserRecord,
  UsersPagination,
  UsersQuery,
} from "../types/users.types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faSearch,
  faEye,
  faMapMarkerAlt,
  faClipboardQuestion,
  faUserPlus,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { Modal, Box, Typography, Button } from "@mui/material";
import { toast } from "react-hot-toast";
import AccountTypeSelect from "../components/AccountTypeSelect";
import AccountDetails from "../components/AccountDetails";
interface DefaultAddressObject {
  phoneNumber?: string;
  address?: string;
  City?: string;
  city?: string;
  number?: string;
  street?: string;
  additionalInfo?: string;
  addressId?: string;
  id?: string;
  title?: string;
  nearestPoint?: string;
  gate?: string;
  addressName?: string;
  province?: string;
  locationName?: string;
  updatedAt?: any;

  location?: {
    latitude?: number;
    longitude?: number;
    latitudeDelta?: number;
    longitudeDelta?: number;
  };
}


const agentAccountLevels = [
  "AgentA",
  "AgentB",
  "AgentC",
  "AgentD",
  "AgentE",
  "AgentF",
  "AgentG",
  "AgentH",
];

const technicianAccountLevels = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
];

const getAccountLevels = (
  accountType: string,
): string[] => {
  if (accountType === "وكيل") {
    return agentAccountLevels;
  }

  if (
    accountType === "منصب" ||
    accountType === "تقني" ||
    accountType === "حساب منصب"
  ) {
    return technicianAccountLevels;
  }

  return [];
};
interface AccountItem
  extends Omit<
    UserRecord,
    | "email"
    | "phoneNumber"
    | "profileImageUrl"
    | "accountType"
    | "province"
    | "defaultAddress"
  > {
  email: string;
  phoneNumber: string;
  profileImageUrl: string;
  accountType: string;
  province?: string;

  defaultAddress?:
    | string
    | DefaultAddressObject
    | null;

  about: string;
  dateOfBirth: string;
  gender: string;
  rating: string;
}


interface AppQuestionForm {
  technicianRequest: string;
  serialsRead: string;
  hasAppNotes: string;
  needsAppInfo: string;
  hasDefaultAddress: string;
  appRating: string;
  notes: string;
}

interface CreateAccountForm {
  fullName: string;
  email: string;
  password: string;
  confirmPassword: string;
  phoneNumber: string;
  accountType: string;
  province: string;
  AccountLevel: string;
}

interface EmailLoginForm {
  email: string;
  password: string;
  confirmPassword: string;
  emailVerified: boolean;
}

interface EmailLoginForm {
  email: string;
  password: string;
  confirmPassword: string;
  emailVerified: boolean;
}

const mapApiUserToAccount = (
  user: UserRecord,
): AccountItem => {
  const raw =
    user.raw &&
    typeof user.raw === "object"
      ? user.raw
      : {};

  return {
    ...user,

    id:
      user.id ||
      user.uid,

    uid:
      user.uid ||
      user.id,

    fullName:
      user.fullName || "",

    email:
      user.email || "",

    phoneNumber:
      user.phoneNumber || "",

    profileImageUrl:
      user.profileImageUrl || "",

    accountType:
      user.accountType || "مستخدم",

    AccountLevel:
      user.AccountLevel || null,

    province:
      user.province || "",

    points:
      Number(user.points || 0),

    Points:
      user.Points ||
      String(user.points || 0),

    defaultAddress:
      user.defaultAddress as
        | string
        | DefaultAddressObject
        | null,

    about:
      typeof raw.about === "string"
        ? raw.about
        : "",

    dateOfBirth:
      typeof raw.dateOfBirth === "string"
        ? raw.dateOfBirth
        : "",

    gender:
      typeof raw.gender === "string"
        ? raw.gender
        : "",

    rating:
      raw.rating !== undefined &&
      raw.rating !== null
        ? String(raw.rating)
        : "",
  };
};

const Account: React.FC = () => {
  const [products, setProducts] = useState<AccountItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [
  loadingMore,
  setLoadingMore,
] = useState<boolean>(false);
  const [
  usersPagination,
  setUsersPagination,
] = useState<UsersPagination>({
  limit: 100,
  hasMore: false,
  nextCursor: null,
});
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [
  debouncedSearchQuery,
  setDebouncedSearchQuery,
] = useState<string>("");

const [
  accountTypeFilter,
  setAccountTypeFilter,
] = useState<string>("");

const [
  provinceFilter,
  setProvinceFilter,
] = useState<string>("");
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [
  disablingUserId,
  setDisablingUserId,
] = useState<string | null>(null);

const [
  enablingUserId,
  setEnablingUserId,
] = useState<string | null>(null);

const [
  disableReason,
  setDisableReason,
] = useState("");
  const navigate = useNavigate();

  const [
  blockingUserId,
  setBlockingUserId,
] = useState<string | null>(null);

const [
  unblockingUserId,
  setUnblockingUserId,
] = useState<string | null>(null);

const [
  blockModalOpen,
  setBlockModalOpen,
] = useState(false);

const [
  selectedBlockUser,
  setSelectedBlockUser,
] = useState<AccountItem | null>(null);

const [
  blockReason,
  setBlockReason,
] = useState("");

const [
  accountChangeModalOpen,
  setAccountChangeModalOpen,
] = useState(false);

const [
  accountChangeUser,
  setAccountChangeUser,
] = useState<AccountItem | null>(null);

const [
  pendingAccountType,
  setPendingAccountType,
] = useState("");

const [
  pendingAccountLevel,
  setPendingAccountLevel,
] = useState("");

const [
  accountChangeReason,
  setAccountChangeReason,
] = useState("");

const [
  updatingAccountUserId,
  setUpdatingAccountUserId,
] = useState<string | null>(null);

const [
  updatingProvinceUserId,
  setUpdatingProvinceUserId,
] = useState<string | null>(null);

  const [selectedAccountDetails, setSelectedAccountDetails] =
  useState<AccountItem  | null>(null);
const [
  provincesList,
  setProvincesList,
] = useState<ProvinceRecord[]>(
  [],
);
  const [addressesModalOpen, setAddressesModalOpen] = useState<boolean>(false);
const [addressesLoading, setAddressesLoading] = useState<boolean>(false);
const [selectedAddressUser, setSelectedAddressUser] = useState<AccountItem  | null>(null);
const [userAddresses, setUserAddresses] = useState<UserAddress[]>([]);
const [accountDetailsOpen, setAccountDetailsOpen] =
  useState<boolean>(false);

  const [questionsModalOpen, setQuestionsModalOpen] = useState<boolean>(false);
const [selectedQuestionUser, setSelectedQuestionUser] = useState<AccountItem  | null>(null);
const [savingQuestions, setSavingQuestions] = useState<boolean>(false);

const [appQuestionForm, setAppQuestionForm] = useState<AppQuestionForm>({
  technicianRequest: "",
  serialsRead: "",
  hasAppNotes: "",
  needsAppInfo: "",
  hasDefaultAddress: "",
  appRating: "",
  notes: "",
});

const [
  emailLoginModalOpen,
  setEmailLoginModalOpen,
] = useState<boolean>(false);

const [
  selectedEmailLoginUser,
  setSelectedEmailLoginUser,
] = useState<AccountItem | null>(
  null,
);

const [
  savingEmailLogin,
  setSavingEmailLogin,
] = useState<boolean>(false);

const [
  showEmailLoginPassword,
  setShowEmailLoginPassword,
] = useState<boolean>(false);

const [
  emailLoginForm,
  setEmailLoginForm,
] = useState<EmailLoginForm>({
  email: "",
  password: "",
  confirmPassword: "",
  emailVerified: false,
});

useEffect(() => {
  const timeoutId = window.setTimeout(() => {
    setDebouncedSearchQuery(
      searchQuery.trim(),
    );
  }, 500);

  return () => {
    window.clearTimeout(timeoutId);
  };
}, [searchQuery]);


const fetchAccounts = useCallback(
  async (
    options: {
      showLoading?: boolean;
      append?: boolean;
      cursor?: string;
    } = {},
  ) => {
    const {
      showLoading = true,
      append = false,
      cursor,
    } = options;

    try {
      if (append) {
        setLoadingMore(true);
      } else if (showLoading) {
        setLoading(true);
      }

      const query: UsersQuery = {
        limit: 100,
        sort: "createdAt_desc",
      };

      if (debouncedSearchQuery) {
        query.search =
          debouncedSearchQuery;
      }

      if (accountTypeFilter) {
        query.accountType =
          accountTypeFilter;
      }

      if (provinceFilter) {
        query.province =
          provinceFilter;
      }

      if (cursor) {
        query.cursor = cursor;
      }

      const result =
        await usersApi.list(query);

      const mappedAccounts =
        result.users.map(
          mapApiUserToAccount,
        );

      if (append) {
        setProducts((previousAccounts) => {
          const accountsMap =
            new Map<string, AccountItem>();

          for (
            const account
            of previousAccounts
          ) {
            accountsMap.set(
              account.id,
              account,
            );
          }

          for (
            const account
            of mappedAccounts
          ) {
            accountsMap.set(
              account.id,
              account,
            );
          }

          return Array.from(
            accountsMap.values(),
          );
        });
      } else {
        setProducts(
          mappedAccounts,
        );
      }

      setUsersPagination(
        result.pagination,
      );
    } catch (error) {
      console.error(
        "Error fetching accounts from API:",
        error,
      );

      if (error instanceof ApiError) {
        if (error.status === 401) {
          toast.error(
            "انتهت جلسة تسجيل الدخول، يرجى تسجيل الدخول مجددًا",
            {
              duration: 4000,
              position: "top-right",
            },
          );

          return;
        }

        if (error.status === 403) {
          toast.error(
            "لا تمتلك صلاحية عرض المستخدمين",
            {
              duration: 4000,
              position: "top-right",
            },
          );

          return;
        }

        toast.error(
          error.message ||
            "حدث خطأ أثناء جلب المستخدمين",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      toast.error(
        "تعذر الاتصال بالخادم أثناء جلب المستخدمين",
        {
          duration: 4000,
          position: "top-right",
        },
      );
    } finally {
      if (append) {
        setLoadingMore(false);
      } else if (showLoading) {
        setLoading(false);
      }
    }
  },
  [
    debouncedSearchQuery,
    accountTypeFilter,
    provinceFilter,
  ],
);

const handleLoadMore = async () => {
  if (loadingMore) {
    return;
  }

  if (
    !usersPagination.hasMore ||
    !usersPagination.nextCursor
  ) {
    return;
  }

  await fetchAccounts({
    append: true,
    showLoading: false,
    cursor:
      usersPagination.nextCursor,
  });
};

const fetchProvinces =
  async () => {
    try {
      const result =
        await provincesApi.list();

      setProvincesList(
        result.provinces,
      );
    } catch (error) {
      console.error(
        "Error fetching provinces from API:",
        error,
      );

      if (
        error instanceof ApiError
      ) {
        if (
          error.status === 403
        ) {
          toast.error(
            "لا تمتلك صلاحية عرض المحافظات",
            {
              duration: 3000,
              position:
                "top-right",
            },
          );

          return;
        }

        toast.error(
          error.message ||
            "حدث خطأ أثناء جلب المحافظات",
          {
            duration: 3000,
            position:
              "top-right",
          },
        );

        return;
      }

      toast.error(
        "تعذر الاتصال بالخادم أثناء جلب المحافظات",
        {
          duration: 3000,
          position:
            "top-right",
        },
      );
    }
  };

const [createAccountModalOpen, setCreateAccountModalOpen] =
  useState<boolean>(false);

const [creatingAccount, setCreatingAccount] =
  useState<boolean>(false);

const [showCreatePassword, setShowCreatePassword] =
  useState<boolean>(false);

const [createAccountForm, setCreateAccountForm] =
  useState<CreateAccountForm>({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phoneNumber: "",
    accountType: "مستخدم",
    province: "",
    AccountLevel: "",
  });

useEffect(() => {
  fetchProvinces();
}, []);
useEffect(() => {
  fetchAccounts();
}, [fetchAccounts]);

  // فتح المودال عند الضغط على زر الحذف
const handleOpenModal = (
  id: string,
) => {
  setSelectedUserId(id);
  setDisableReason("");
  setOpenModal(true);
};
  // إغلاق المودال بدون حذف الحساب
const handleCloseModal = () => {
  if (disablingUserId) {
    return;
  }

  setSelectedUserId(null);
  setDisableReason("");
  setOpenModal(false);
};

  // Filter products based on search query
  //   const filteredProducts = products.filter((product) =>
  //     product.fullName.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  const handleEdit = (id: string) => {
    navigate(`/dashboard/EditAccount/${id}`);
  };

  const handleViewAccount = (account: AccountItem) => {
  setSelectedAccountDetails(account);
  setAccountDetailsOpen(true);
};

const handleCloseAccountDetails = () => {
  setAccountDetailsOpen(false);
  setSelectedAccountDetails(null);
};

const handleDisableUser = async () => {
  if (
    !selectedUserId ||
    disablingUserId
  ) {
    return;
  }

  const selectedUser =
    products.find(
      (user) =>
        user.id === selectedUserId,
    );

  if (!selectedUser) {
    toast.error(
      "لم يتم العثور على بيانات المستخدم",
      {
        duration: 3000,
        position: "top-right",
      },
    );

    return;
  }

  if (selectedUser.authDisabled) {
    toast.error(
      "هذا الحساب معطل بالفعل",
      {
        duration: 3000,
        position: "top-right",
      },
    );

    return;
  }

  try {
    setDisablingUserId(
      selectedUserId,
    );

    await usersApi.disable(
      selectedUserId,
      {
        reason:
          disableReason.trim() ||
          "تم تعطيل الحساب من لوحة التحكم",
      },
    );

    setProducts(
      (previousAccounts) =>
        previousAccounts.map(
          (account) =>
            account.id ===
            selectedUserId
              ? {
                  ...account,
                  authDisabled: true,
                  status: "disabled",
                }
              : account,
        ),
    );

    toast.success(
      "تم تعطيل الحساب بنجاح",
      {
        duration: 3000,
        position: "top-right",
        className:
          "accounts-toast-success",
      },
    );

    setOpenModal(false);
    setSelectedUserId(null);
    setDisableReason("");

    await fetchAccounts({
      showLoading: false,
    });
  } catch (error) {
    console.error(
      "Error disabling user:",
      error,
    );

    if (error instanceof ApiError) {
      if (error.status === 403) {
        toast.error(
          "لا تمتلك صلاحية تعطيل الحسابات",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 404) {
        toast.error(
          "لم يتم العثور على المستخدم",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 409) {
        toast.error(
          error.message ||
            "الحساب معطل بالفعل",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      toast.error(
        error.message ||
          "حدث خطأ أثناء تعطيل الحساب",
        {
          duration: 4000,
          position: "top-right",
        },
      );

      return;
    }

    toast.error(
      "تعذر الاتصال بالخادم أثناء تعطيل الحساب",
      {
        duration: 4000,
        position: "top-right",
      },
    );
  } finally {
    setDisablingUserId(null);
  }
};


const handleEnableUser = async (
  user: AccountItem,
) => {
  if (enablingUserId) {
    return;
  }

  if (
    !user.authDisabled &&
    user.status !== "disabled"
  ) {
    toast.error(
      "هذا الحساب نشط بالفعل",
      {
        duration: 3000,
        position: "top-right",
      },
    );

    return;
  }

  const confirmed = window.confirm(
    `هل تريد إعادة تفعيل حساب المستخدم "${
      user.fullName ||
      user.phoneNumber ||
      user.id
    }"؟`,
  );

  if (!confirmed) {
    return;
  }

  try {
    setEnablingUserId(
      user.id,
    );

    await usersApi.enable(
      user.id,
      {
        reason:
          "تمت إعادة تفعيل الحساب من لوحة التحكم",
      },
    );

    setProducts(
      (previousAccounts) =>
        previousAccounts.map(
          (account) =>
            account.id === user.id
              ? {
                  ...account,
                  authDisabled: false,
                  status: "active",
                }
              : account,
        ),
    );

    toast.success(
      "تمت إعادة تفعيل الحساب بنجاح",
      {
        duration: 3000,
        position: "top-right",
        className:
          "accounts-toast-success",
      },
    );

    await fetchAccounts({
      showLoading: false,
    });
  } catch (error) {
    console.error(
      "Error enabling user:",
      error,
    );

    if (error instanceof ApiError) {
      if (error.status === 403) {
        toast.error(
          "لا تمتلك صلاحية إعادة تفعيل الحسابات",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 404) {
        toast.error(
          "لم يتم العثور على المستخدم",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 409) {
        toast.error(
          error.message ||
            "الحساب نشط بالفعل",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      toast.error(
        error.message ||
          "حدث خطأ أثناء إعادة تفعيل الحساب",
        {
          duration: 4000,
          position: "top-right",
        },
      );

      return;
    }

    toast.error(
      "تعذر الاتصال بالخادم أثناء إعادة تفعيل الحساب",
      {
        duration: 4000,
        position: "top-right",
      },
    );
  } finally {
    setEnablingUserId(null);
  }
};


const handleOpenBlockModal = (
  user: AccountItem,
) => {
  if (
    user.authDisabled ||
    user.status === "disabled"
  ) {
    toast.error(
      "لا يمكن حظر حساب معطل",
      {
        duration: 3000,
        position: "top-right",
      },
    );

    return;
  }

  if (
    user.isBlocked ||
    user.status === "blocked"
  ) {
    toast.error(
      "هذا الحساب محظور بالفعل",
      {
        duration: 3000,
        position: "top-right",
      },
    );

    return;
  }

  setSelectedBlockUser(user);
  setBlockReason("");
  setBlockModalOpen(true);
};


const handleCloseBlockModal = () => {
  if (blockingUserId) {
    return;
  }

  setBlockModalOpen(false);
  setSelectedBlockUser(null);
  setBlockReason("");
};

const handleBlockUser = async () => {
  if (
    !selectedBlockUser ||
    blockingUserId
  ) {
    return;
  }

  if (!blockReason.trim()) {
    toast.error(
      "يرجى كتابة سبب الحظر",
      {
        duration: 3000,
        position: "top-right",
      },
    );

    return;
  }

  try {
    setBlockingUserId(
      selectedBlockUser.id,
    );

    await usersApi.block(
      selectedBlockUser.id,
      {
        reason:
          blockReason.trim(),
      },
    );

    setProducts(
      (previousAccounts) =>
        previousAccounts.map(
          (account) =>
            account.id ===
            selectedBlockUser.id
              ? {
                  ...account,
                  isBlocked: true,
                  status: "blocked",
                  blockedReason:
                    blockReason.trim(),
                }
              : account,
        ),
    );

    toast.success(
      "تم حظر المستخدم بنجاح",
      {
        duration: 3000,
        position: "top-right",
        className:
          "accounts-toast-success",
      },
    );

    setBlockModalOpen(false);
    setSelectedBlockUser(null);
    setBlockReason("");

    await fetchAccounts({
      showLoading: false,
    });
  } catch (error) {
    console.error(
      "Error blocking user:",
      error,
    );

    if (error instanceof ApiError) {
      if (error.status === 403) {
        toast.error(
          "لا تمتلك صلاحية حظر المستخدمين",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 404) {
        toast.error(
          "لم يتم العثور على المستخدم",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 409) {
        toast.error(
          error.message ||
            "المستخدم محظور بالفعل",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      toast.error(
        error.message ||
          "حدث خطأ أثناء حظر المستخدم",
        {
          duration: 4000,
          position: "top-right",
        },
      );

      return;
    }

    toast.error(
      "تعذر الاتصال بالخادم أثناء حظر المستخدم",
      {
        duration: 4000,
        position: "top-right",
      },
    );
  } finally {
    setBlockingUserId(null);
  }
};

const handleUnblockUser = async (
  user: AccountItem,
) => {
  if (unblockingUserId) {
    return;
  }

  if (
    !user.isBlocked &&
    user.status !== "blocked"
  ) {
    toast.error(
      "هذا الحساب غير محظور",
      {
        duration: 3000,
        position: "top-right",
      },
    );

    return;
  }

  if (
    user.authDisabled ||
    user.status === "disabled"
  ) {
    toast.error(
      "لا يمكن إلغاء حظر حساب معطل قبل إعادة تفعيله",
      {
        duration: 3000,
        position: "top-right",
      },
    );

    return;
  }

  const confirmed = window.confirm(
    `هل تريد إلغاء حظر المستخدم "${
      user.fullName ||
      user.phoneNumber ||
      user.id
    }"؟`,
  );

  if (!confirmed) {
    return;
  }

  try {
    setUnblockingUserId(
      user.id,
    );

    await usersApi.unblock(
      user.id,
      {
        reason:
          "تم إلغاء الحظر من لوحة التحكم",
      },
    );

    setProducts(
      (previousAccounts) =>
        previousAccounts.map(
          (account) =>
            account.id === user.id
              ? {
                  ...account,
                  isBlocked: false,
                  status: "active",
                  blockedReason: null,
                }
              : account,
        ),
    );

    toast.success(
      "تم إلغاء حظر المستخدم بنجاح",
      {
        duration: 3000,
        position: "top-right",
        className:
          "accounts-toast-success",
      },
    );

    await fetchAccounts({
      showLoading: false,
    });
  } catch (error) {
    console.error(
      "Error unblocking user:",
      error,
    );

    if (error instanceof ApiError) {
      if (error.status === 401) {
        toast.error(
          "انتهت جلسة تسجيل الدخول، يرجى تسجيل الدخول مجددًا",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 403) {
        toast.error(
          "لا تمتلك صلاحية إلغاء حظر المستخدمين",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 404) {
        toast.error(
          "لم يتم العثور على المستخدم",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 409) {
        toast.error(
          error.message ||
            "هذا الحساب غير محظور",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      toast.error(
        error.message ||
          "حدث خطأ أثناء إلغاء الحظر",
        {
          duration: 4000,
          position: "top-right",
        },
      );

      return;
    }

    toast.error(
      "تعذر الاتصال بالخادم أثناء إلغاء الحظر",
      {
        duration: 4000,
        position: "top-right",
      },
    );
  } finally {
    setUnblockingUserId(null);
  }
};

const displayedProducts =
  products;

const handleOpenAccountChange = (
user: AccountItem,
  newAccountType: string,
) => {
  if (!newAccountType) {
    return;
  }

  if (
    newAccountType === user.accountType
  ) {
    return;
  }

  setAccountChangeUser(user);

  setPendingAccountType(
    newAccountType,
  );

  const availableLevels =
    getAccountLevels(
      newAccountType,
    );

  if (
    availableLevels.includes(
      user.AccountLevel || "",
    )
  ) {
    setPendingAccountLevel(
      user.AccountLevel || "",
    );
  } else {
    setPendingAccountLevel("");
  }

  setAccountChangeReason("");

  setAccountChangeModalOpen(true);
};

  const formatCreatedAt = (createdAt: any) => {
  if (!createdAt) return "غير متوفر";

  // إذا كان الحقل من نوع Firestore Timestamp
  if (createdAt?.toDate) {
    return createdAt.toDate().toLocaleString("ar-IQ", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  // إذا كان محفوظ كنص أو Date عادي
  const date = new Date(createdAt);
  if (isNaN(date.getTime())) return "غير متوفر";

  return date.toLocaleString("ar-IQ", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};


const handleCloseAccountChange = () => {
  if (updatingAccountUserId) {
    return;
  }

  setAccountChangeModalOpen(false);

  setAccountChangeUser(null);

  setPendingAccountType("");

  setPendingAccountLevel("");

  setAccountChangeReason("");
};


const handleConfirmAccountChange =
  async () => {
    if (
      !accountChangeUser ||
      !pendingAccountType
    ) {
      return;
    }

    const availableLevels =
      getAccountLevels(
        pendingAccountType,
      );

    if (
      availableLevels.length > 0 &&
      !pendingAccountLevel
    ) {
      toast.error(
        "يرجى اختيار مستوى الحساب",
        {
          duration: 3000,
          position: "top-right",
        },
      );

      return;
    }

    try {
      setUpdatingAccountUserId(
        accountChangeUser.id,
      );

      await usersApi.updateAccount(
        accountChangeUser.id,
        {
          accountType:
            pendingAccountType,

          AccountLevel:
            availableLevels.length > 0
              ? pendingAccountLevel
              : null,

          reason:
            accountChangeReason.trim() ||
            "تم تغيير نوع الحساب من لوحة التحكم",
        },
      );

      setProducts(
        (previousAccounts) =>
          previousAccounts.map(
            (account) =>
              account.id ===
              accountChangeUser.id
                ? {
                    ...account,

                    accountType:
                      pendingAccountType,

                    AccountLevel:
                      availableLevels.length >
                      0
                        ? pendingAccountLevel
                        : null,
                  }
                : account,
          ),
      );

      toast.success(
        "تم تحديث نوع ومستوى الحساب بنجاح",
        {
          duration: 3000,
          position: "top-right",
        },
      );

      setAccountChangeModalOpen(false);

      setAccountChangeUser(null);

      setPendingAccountType("");

      setPendingAccountLevel("");

      setAccountChangeReason("");

      await fetchAccounts({
        showLoading: false,
      });
    } catch (error) {
      console.error(
        "Failed to update user account:",
        error,
      );

      if (error instanceof ApiError) {
        if (error.status === 403) {
          toast.error(
            "لا تمتلك صلاحية تغيير نوع الحساب",
            {
              duration: 4000,
              position: "top-right",
            },
          );

          return;
        }

        if (error.status === 404) {
          toast.error(
            "لم يتم العثور على المستخدم",
            {
              duration: 4000,
              position: "top-right",
            },
          );

          return;
        }

        if (error.status === 409) {
          toast.error(
            error.message ||
              "لا يمكن تنفيذ تغيير الحساب",
            {
              duration: 4000,
              position: "top-right",
            },
          );

          return;
        }

        toast.error(
          error.message ||
            "حدث خطأ أثناء تغيير الحساب",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      toast.error(
        "تعذر الاتصال بالخادم أثناء تغيير الحساب",
        {
          duration: 4000,
          position: "top-right",
        },
      );
    } finally {
      setUpdatingAccountUserId(null);
    }
  };
const handleOpenAddresses = async (
  user: AccountItem,
) => {
  if (addressesLoading) {
    return;
  }

  setSelectedAddressUser(user);
  setUserAddresses([]);
  setAddressesModalOpen(true);
  setAddressesLoading(true);

  try {
    const result =
      await usersApi.getAddresses(
        user.id,
      );

    setUserAddresses(
      result.items,
    );
  } catch (error) {
    console.error(
      "Error fetching user addresses from API:",
      error,
    );

    if (error instanceof ApiError) {
      if (error.status === 401) {
        toast.error(
          "انتهت جلسة تسجيل الدخول، يرجى تسجيل الدخول مجددًا",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 403) {
        toast.error(
          "لا تمتلك صلاحية عرض عناوين المستخدمين",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 404) {
        toast.error(
          "لم يتم العثور على المستخدم",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      toast.error(
        error.message ||
          "حدث خطأ أثناء جلب عناوين المستخدم",
        {
          duration: 4000,
          position: "top-right",
        },
      );

      return;
    }

    toast.error(
      "تعذر الاتصال بالخادم أثناء جلب العناوين",
      {
        duration: 4000,
        position: "top-right",
      },
    );
  } finally {
    setAddressesLoading(false);
  }
};

const handleUpdateUserProvince = async (
  user: AccountItem,
  provinceId: string,
) => {
  if (updatingProvinceUserId) {
    return;
  }

  if (provinceId === user.province) {
    return;
  }

  const provinceName =
    provincesList.find(
      (province) =>
        province.id === provinceId,
    )?.name?.ar ||
    provincesList.find(
      (province) =>
        province.id === provinceId,
    )?.name?.en ||
    provinceId ||
    "بدون محافظة";

  const confirmed = window.confirm(
    `هل تريد تغيير محافظة المستخدم إلى "${provinceName}"؟`,
  );

  if (!confirmed) {
    return;
  }

  const previousProvince =
    user.province || "";

  try {
    setUpdatingProvinceUserId(
      user.id,
    );

    setProducts(
      (previousAccounts) =>
        previousAccounts.map(
          (account) =>
            account.id === user.id
              ? {
                  ...account,
                  province:
                    provinceId,
                }
              : account,
        ),
    );

    await usersApi.update(
      user.id,
      {
        province:
          provinceId || null,
      },
    );

    toast.success(
      "تم تحديث محافظة المستخدم بنجاح",
      {
        duration: 3000,
        position: "top-right",
        className:
          "accounts-toast-success",
      },
    );

    await fetchAccounts({
      showLoading: false,
    });
  } catch (error) {
    console.error(
      "Error updating user province:",
      error,
    );

    setProducts(
      (previousAccounts) =>
        previousAccounts.map(
          (account) =>
            account.id === user.id
              ? {
                  ...account,
                  province:
                    previousProvince,
                }
              : account,
        ),
    );

    if (error instanceof ApiError) {
      if (error.status === 403) {
        toast.error(
          "لا تمتلك صلاحية تعديل بيانات المستخدم",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 404) {
        toast.error(
          "لم يتم العثور على المستخدم",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      if (error.status === 400) {
        toast.error(
          error.message ||
            "قيمة المحافظة غير صحيحة",
          {
            duration: 4000,
            position: "top-right",
          },
        );

        return;
      }

      toast.error(
        error.message ||
          "حدث خطأ أثناء تحديث المحافظة",
        {
          duration: 4000,
          position: "top-right",
        },
      );

      return;
    }

    toast.error(
      "تعذر الاتصال بالخادم أثناء تحديث المحافظة",
      {
        duration: 4000,
        position: "top-right",
      },
    );
  } finally {
    setUpdatingProvinceUserId(null);
  }
};
const handleCloseAddressesModal = () => {
  setAddressesModalOpen(false);
  setSelectedAddressUser(null);
  setUserAddresses([]);
};
const buildAddressText = (
  address: UserAddress,
): string => {
  const parts = [
    address.addressName,
    address.province,
    address.City,
    address.address,
    address.gate,
    address.locationName,
    address.phoneNumber,
  ].filter(
    (item): item is string =>
      typeof item === "string" &&
      item.trim() !== "",
  );

  return parts.join(" - ");
};


const formatDefaultAddress = (
defaultAddress: AccountItem["defaultAddress"]
): string => {
  if (!defaultAddress) {
    return "لا يوجد";
  }

  // الحالة القديمة: defaultAddress عبارة عن ID
  if (typeof defaultAddress === "string") {
    return defaultAddress.trim() || "لا يوجد";
  }

  // حماية إضافية
  if (typeof defaultAddress !== "object") {
    return String(defaultAddress);
  }

  // إذا كان الكائن يحتوي على ID للعنوان
  const addressId =
    defaultAddress.addressId ||
    defaultAddress.id;

  // محاولة تكوين نص مفهوم للمستخدم
  const addressParts = [
    defaultAddress.addressName,
    defaultAddress.title,
    defaultAddress.province,
    defaultAddress.City,
    defaultAddress.city,
    defaultAddress.locationName,
    defaultAddress.address,
    defaultAddress.street,
    defaultAddress.gate,
    defaultAddress.nearestPoint,
  ].filter(
    (value): value is string =>
      typeof value === "string" &&
      value.trim() !== ""
  );

  if (addressParts.length > 0) {
    return addressParts.join(" - ");
  }

  // إذا لم نجد وصفاً، نعرض ID
  if (addressId) {
    return addressId;
  }

  return "عنوان محفوظ";
};

const handleSetDefaultAddress =
  async (
    address: UserAddress,
  ) => {
    if (
      !selectedAddressUser
    ) {
      return;
    }

    const confirmed =
      window.confirm(
        "هل تريد تعيين هذا العنوان كعنوان افتراضي للمستخدم؟",
      );

    if (!confirmed) {
      return;
    }

    try {
      const result =
        await usersApi.setDefaultAddress(
          selectedAddressUser.id,
          address.addressId,
        );

      setProducts(
        (previous) =>
          previous.map(
            (user) =>
              user.id ===
              selectedAddressUser.id
                ? {
                    ...user,

                    defaultAddress:
                      result.address,
                  }
                : user,
          ),
      );

      setUserAddresses(
        (previous) =>
          previous.map(
            (item) => ({
              ...item,

              isDefault:
                item.addressId ===
                address.addressId,
            }),
          ),
      );

      toast.success(
        "تم تعيين العنوان الافتراضي للمستخدم بنجاح",
        {
          duration: 3000,
          position:
            "top-right",
          className:
            "accounts-toast-success",
        },
      );

      handleCloseAddressesModal();
    } catch (error) {
      console.error(
        "Error setting default address:",
        error,
      );

      if (
        error instanceof ApiError
      ) {
        if (
          error.status === 403
        ) {
          toast.error(
            "لا تمتلك صلاحية تعديل عنوان المستخدم",
          );

          return;
        }

        if (
          error.status === 404
        ) {
          toast.error(
            "لم يتم العثور على العنوان",
          );

          return;
        }

        toast.error(
          error.message ||
            "حدث خطأ أثناء تعيين العنوان الافتراضي",
        );

        return;
      }

      toast.error(
        "تعذر الاتصال بالخادم",
      );
    }
  };

const handleOpenQuestionsModal = (
  user: AccountItem,
) => {
  setSelectedQuestionUser(user);

  setAppQuestionForm({
    technicianRequest: "",
    serialsRead: "",
    hasAppNotes: "",
    needsAppInfo: "",
    hasDefaultAddress: user.defaultAddress ? "yes" : "",
    appRating: "",
    notes: "",
  });

  setQuestionsModalOpen(true);
};

const handleCloseQuestionsModal = () => {
  if (savingQuestions) return;

  setQuestionsModalOpen(false);
  setSelectedQuestionUser(null);

  setAppQuestionForm({
    technicianRequest: "",
    serialsRead: "",
    hasAppNotes: "",
    needsAppInfo: "",
    hasDefaultAddress: "",
    appRating: "",
    notes: "",
  });
};

const handleQuestionChange = (field: keyof AppQuestionForm, value: string) => {
  setAppQuestionForm((prev) => ({
    ...prev,
    [field]: value,
  }));
};

const handleSaveAppQuestions =
  async () => {
    if (
      !selectedQuestionUser
    ) {
      return;
    }

    if (
      !appQuestionForm.appRating
    ) {
      toast.error(
        "يرجى اختيار تقييم التطبيق من ٥ درجات",
        {
          duration: 3000,
          position:
            "top-right",
        },
      );

      return;
    }

    try {
      setSavingQuestions(
        true,
      );

      await usersApi.createAppQuestion(
        selectedQuestionUser.id,
        {
          technicianRequest:
            appQuestionForm
              .technicianRequest,

          serialsRead:
            appQuestionForm
              .serialsRead,

          hasAppNotes:
            appQuestionForm
              .hasAppNotes,

          needsAppInfo:
            appQuestionForm
              .needsAppInfo,

          hasDefaultAddress:
            appQuestionForm
              .hasDefaultAddress,

          appRating:
            Number(
              appQuestionForm
                .appRating,
            ),

          notes:
            appQuestionForm
              .notes
              .trim(),
        },
      );

      toast.success(
        "تم حفظ بيانات المتابعة بنجاح",
        {
          duration: 3000,
          position:
            "top-right",
          className:
            "accounts-toast-success",
        },
      );

      handleCloseQuestionsModal();
    } catch (error) {
      console.error(
        "Error saving app questions:",
        error,
      );

      if (
        error instanceof ApiError
      ) {
        if (
          error.status === 403
        ) {
          toast.error(
            "لا تمتلك صلاحية حفظ بيانات المتابعة",
          );

          return;
        }

        if (
          error.status === 404
        ) {
          toast.error(
            "لم يتم العثور على المستخدم",
          );

          return;
        }

        toast.error(
          error.message ||
            "حدث خطأ أثناء حفظ بيانات المتابعة",
        );

        return;
      }

      toast.error(
        "تعذر الاتصال بالخادم أثناء حفظ بيانات المتابعة",
      );
    } finally {
      setSavingQuestions(
        false,
      );
    }
  };


const resetCreateAccountForm = () => {
  setCreateAccountForm({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phoneNumber: "",
    accountType: "مستخدم",
    province: "",
    AccountLevel: "",
  });

  setShowCreatePassword(false);
};

const handleOpenCreateAccountModal = () => {
  resetCreateAccountForm();
  setCreateAccountModalOpen(true);
};

const handleCloseCreateAccountModal = () => {
  if (creatingAccount) return;

  setCreateAccountModalOpen(false);
  resetCreateAccountForm();
};

const handleCreateAccountChange = (
  field: keyof CreateAccountForm,
  value: string
) => {
  setCreateAccountForm((previous) => ({
    ...previous,
    [field]: value,
  }));
};

const validateCreateAccountForm = () => {
  const fullName = createAccountForm.fullName.trim();
  const email = createAccountForm.email.trim().toLowerCase();
  const password = createAccountForm.password;

  if (fullName.length < 2) {
    toast.error("يرجى كتابة الاسم الكامل", {
      duration: 3000,
      position: "top-right",
    });

    return false;
  }

  if (!email) {
    toast.error("يرجى كتابة البريد الإلكتروني", {
      duration: 3000,
      position: "top-right",
    });

    return false;
  }

  const emailPattern =
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailPattern.test(email)) {
    toast.error("صيغة البريد الإلكتروني غير صحيحة", {
      duration: 3000,
      position: "top-right",
    });

    return false;
  }

  if (password.length < 6) {
    toast.error("يجب أن تتكون كلمة المرور من 6 أحرف على الأقل", {
      duration: 3000,
      position: "top-right",
    });

    return false;
  }

  if (
    createAccountForm.password !==
    createAccountForm.confirmPassword
  ) {
    toast.error("كلمتا المرور غير متطابقتين", {
      duration: 3000,
      position: "top-right",
    });

    return false;
  }

  if (!createAccountForm.accountType) {
    toast.error("يرجى اختيار نوع الحساب", {
      duration: 3000,
      position: "top-right",
    });

    return false;
  }

  return true;
};

const handleCreateAccount = async () => {
  if (creatingAccount) return;

  if (!validateCreateAccountForm()) {
    return;
  }

  try {
    setCreatingAccount(true);

  await usersApi.create({
  fullName: createAccountForm.fullName.trim(),
  email: createAccountForm.email
    .trim()
    .toLowerCase(),
  password: createAccountForm.password,

  phoneNumber:
    createAccountForm.phoneNumber.trim() ||
    undefined,

  accountType:
    createAccountForm.accountType,

  province:
    createAccountForm.province ||
    null,

  AccountLevel:
    createAccountForm.AccountLevel ||
    null,

  language: "ar",
  emailVerified: false,
});

   toast.success(
  "تم إنشاء الحساب في Authentication وFirestore بنجاح",
  {
    duration: 4000,
    position: "top-right",
    className: "accounts-toast-success",
  }
);

setCreateAccountModalOpen(false);
resetCreateAccountForm();

await fetchAccounts({
  showLoading: false,
});
  } catch (error: any) {
    console.error("Error creating account:", error);

    const errorCode =
      error?.code ||
      error?.details?.error?.code ||
      error?.data?.error?.code;

    if (errorCode === "EMAIL_ALREADY_EXISTS") {
      toast.error("البريد الإلكتروني مستخدم مسبقًا", {
        duration: 4000,
        position: "top-right",
      });

      return;
    }

    if (errorCode === "INVALID_EMAIL") {
      toast.error("البريد الإلكتروني غير صالح", {
        duration: 4000,
        position: "top-right",
      });

      return;
    }

    if (errorCode === "INVALID_PASSWORD") {
      toast.error("كلمة المرور غير صالحة", {
        duration: 4000,
        position: "top-right",
      });

      return;
    }

    if (error?.status === 403) {
      toast.error("لا تمتلك صلاحية إنشاء حسابات", {
        duration: 4000,
        position: "top-right",
      });

      return;
    }

    toast.error(
      error?.message || "حدث خطأ أثناء إنشاء الحساب",
      {
        duration: 4000,
        position: "top-right",
      }
    );
  } finally {
    setCreatingAccount(false);
  }
};



const resetEmailLoginForm = () => {
  setEmailLoginForm({
    email: "",
    password: "",
    confirmPassword: "",
    emailVerified: false,
  });

  setShowEmailLoginPassword(
    false,
  );
};

const handleOpenEmailLoginModal = (
  user: AccountItem,
) => {
  setSelectedEmailLoginUser(
    user,
  );

  setEmailLoginForm({
    email:
      user.email || "",

    password:
      "",

    confirmPassword:
      "",

    emailVerified:
      Boolean(
        user.emailVerified,
      ),
  });

  setShowEmailLoginPassword(
    false,
  );

  setEmailLoginModalOpen(
    true,
  );
};

const handleCloseEmailLoginModal =
  () => {
    if (savingEmailLogin) {
      return;
    }

    setEmailLoginModalOpen(
      false,
    );

    setSelectedEmailLoginUser(
      null,
    );

    resetEmailLoginForm();
  };

const handleEmailLoginFormChange = (
  field:
    keyof EmailLoginForm,
  value:
    string | boolean,
) => {
  setEmailLoginForm(
    (previous) => ({
      ...previous,

      [field]:
        value,
    }),
  );
};

const validateEmailLoginForm =
  () => {
    const email =
      emailLoginForm.email
        .trim()
        .toLowerCase();

    const emailPattern =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      toast.error(
        "يرجى كتابة البريد الإلكتروني",
        {
          duration: 3000,
          position:
            "top-right",
        },
      );

      return false;
    }

    if (
      !emailPattern.test(
        email,
      )
    ) {
      toast.error(
        "صيغة البريد الإلكتروني غير صحيحة",
        {
          duration: 3000,
          position:
            "top-right",
        },
      );

      return false;
    }

    if (
      emailLoginForm.password
        .length < 6
    ) {
      toast.error(
        "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
        {
          duration: 3000,
          position:
            "top-right",
        },
      );

      return false;
    }

    if (
      emailLoginForm.password !==
      emailLoginForm.confirmPassword
    ) {
      toast.error(
        "كلمتا المرور غير متطابقتين",
        {
          duration: 3000,
          position:
            "top-right",
        },
      );

      return false;
    }

    return true;
  };

const handleSaveEmailLogin =
  async () => {
    if (
      !selectedEmailLoginUser ||
      savingEmailLogin
    ) {
      return;
    }

    if (
      !validateEmailLoginForm()
    ) {
      return;
    }

    try {
      setSavingEmailLogin(
        true,
      );

      const email =
        emailLoginForm.email
          .trim()
          .toLowerCase();

      const result =
        await usersApi
          .setLoginCredentials(
            selectedEmailLoginUser.id,
            {
              email,

              password:
                emailLoginForm.password,

              emailVerified:
                emailLoginForm.emailVerified,
            },
          );

      setProducts(
        (previousAccounts) =>
          previousAccounts.map(
            (account) =>
              account.id ===
              selectedEmailLoginUser.id
                ? {
                    ...account,

                    email:
                      result
                        .credentials
                        .email,

                    emailVerified:
                      result
                        .credentials
                        .emailVerified,
                  }
                : account,
          ),
      );

      toast.success(
        "تم إعداد تسجيل الدخول بالإيميل لهذا المستخدم بنجاح",
        {
          duration: 4000,
          position:
            "top-right",
          className:
            "accounts-toast-success",
        },
      );

      setEmailLoginModalOpen(
        false,
      );

      setSelectedEmailLoginUser(
        null,
      );

      resetEmailLoginForm();

      await fetchAccounts({
        showLoading:
          false,
      });
    } catch (error) {
      console.error(
        "Error setting user email login credentials:",
        error,
      );

      if (
        error instanceof ApiError
      ) {
        if (
          error.status === 401
        ) {
          toast.error(
            "انتهت جلسة تسجيل الدخول، يرجى تسجيل الدخول مجددًا",
            {
              duration: 4000,
              position:
                "top-right",
            },
          );

          return;
        }

        if (
          error.status === 403
        ) {
          toast.error(
            "لا تمتلك صلاحية تعديل بيانات تسجيل الدخول",
            {
              duration: 4000,
              position:
                "top-right",
            },
          );

          return;
        }

        if (
          error.status === 404
        ) {
          toast.error(
            "لم يتم العثور على حساب المستخدم في Firebase Authentication",
            {
              duration: 4000,
              position:
                "top-right",
            },
          );

          return;
        }

        if (
          error.status === 409
        ) {
          toast.error(
            error.message ||
              "البريد الإلكتروني مستخدم بواسطة حساب آخر",
            {
              duration: 4000,
              position:
                "top-right",
            },
          );

          return;
        }

        if (
          error.status === 400
        ) {
          toast.error(
            error.message ||
              "بيانات البريد أو كلمة المرور غير صحيحة",
            {
              duration: 4000,
              position:
                "top-right",
            },
          );

          return;
        }

        toast.error(
          error.message ||
            "حدث خطأ أثناء إعداد تسجيل الدخول بالإيميل",
          {
            duration: 4000,
            position:
              "top-right",
          },
        );

        return;
      }

      toast.error(
        "تعذر الاتصال بالخادم أثناء إعداد تسجيل الدخول بالإيميل",
        {
          duration: 4000,
          position:
            "top-right",
        },
      );
    } finally {
      setSavingEmailLogin(
        false,
      );
    }
  };

return (
  <div className="accounts-page">
    <div className="accounts-header">
      <h1 className="accounts-title">الــــحــــــــــــســـــــــابـــــات</h1>

<button
  type="button"
  className="accounts-create-btn"
  onClick={handleOpenCreateAccountModal}
>
  <FontAwesomeIcon icon={faUserPlus} />

  <span>إنشاء حساب جديد</span>
</button>
      <div className="accounts-search-box">
        <FontAwesomeIcon icon={faSearch} className="accounts-search-icon" />
        <input
  type="text"
  placeholder="ابحث بالاسم أو الهاتف أو الإيميل..."
  className="accounts-search-input"
  value={searchQuery}
  onChange={(e) =>
    setSearchQuery(
      e.target.value,
    )
  }
/>
      </div>

      <div className="accounts-filter-box">
  <AccountTypeSelect
    id="account-type-filter"
    value={accountTypeFilter}
    includeAllOption
    onChange={(value) =>
      setAccountTypeFilter(value)
    }
  />
</div>

    <select
  value={provinceFilter}
  onChange={(e) => setProvinceFilter(e.target.value)}
  className="accounts-province-select"
>
  <option value="">كل المحافظات</option>

  {provincesList.map((province) => (
    <option key={province.id} value={province.id}>
      {province.name?.ar || province.name?.en || province.id}
    </option>
  ))}
</select>
{(
  searchQuery ||
  accountTypeFilter ||
  provinceFilter
) && (
  <button
    type="button"
    className="accounts-clear-filters-btn"
    onClick={() => {
      setSearchQuery("");
      setDebouncedSearchQuery("");
      setAccountTypeFilter("");
      setProvinceFilter("");
    }}
  >
    مسح البحث والفلاتر
  </button>
)}
    </div>

    {loading ? (
  <div className="accounts-loading">
  جاري تحميل المستخدمين من الخادم...
</div>
    ) : (
      <div className="accounts-table-container">
        <table className="accounts-table">
          <thead>
            <tr>
              <th>#</th>
              <th>الصورة</th>
              <th>الآسم الكامل</th>
              <th>الآيميل</th>
              <th>رقم الهاتف</th>
              <th>التقييم</th>
              <th>النقاط</th>
              <th>تحويل الحالة</th>
              <th>حالة الحساب</th>
             <th>المحافظة</th>
<th>العنوان الافتراضي</th>
<th>العناوين</th>
<th>تاريخ إنشاء الحساب</th>
<th>الإجراء</th>
            </tr>
          </thead>

          <tbody>
          {displayedProducts.map((user, index) => (
              <tr key={user.id}>
                <td>{index + 1}</td>

                <td>
                 {user.profileImageUrl ? (
  <img
    src={user.profileImageUrl}
    alt={
      user.fullName ||
      "صورة الحساب"
    }
    className="accounts-user-image"
  />
) : (
  <div
    className="accounts-user-image accounts-user-image-placeholder"
    title="لا توجد صورة"
  >
    {user.fullName
      ?.trim()
      .charAt(0)
      .toUpperCase() || "؟"}
  </div>
)}
                </td>

                <td className="accounts-cell-text">{user.fullName}</td>
                <td className="accounts-cell-text">{user.email}</td>
                <td className="accounts-cell-text">{user.phoneNumber}</td>
                <td className="accounts-cell-text">{user.rating}</td>
                <td className="accounts-cell-text">{user.points}</td>

                <td className="accounts-type-cell">
    <AccountTypeSelect
  id={`account-type-${user.id}`}
  value={user.accountType || ""}
  includeAllOption={false}
 disabled={
  updatingAccountUserId === user.id ||
  disablingUserId === user.id ||
  enablingUserId === user.id ||
  blockingUserId === user.id ||
  unblockingUserId === user.id
}
  onChange={(newType) =>
    handleOpenAccountChange(
      user,
      newType,
    )
  }
/>
                </td>

            <td className="accounts-status-cell">
  <span
    className={`accounts-status-badge ${
      user.authDisabled ||
      user.status === "disabled"
        ? "accounts-status-disabled"
        : user.isBlocked ||
          user.status === "blocked"
        ? "accounts-status-blocked"
        : user.status === "pending"
        ? "accounts-status-pending"
        : "accounts-status-active"
    }`}
  >
    {user.authDisabled ||
    user.status === "disabled"
      ? "معطل"
      : user.isBlocked ||
        user.status === "blocked"
      ? "محظور"
      : user.status === "pending"
      ? "بانتظار الموافقة"
      : "نشط"}
  </span>
</td>
<td className="accounts-province-cell">
  <select
    value={user.province || ""}
    className="accounts-user-province-select"
    disabled={
      updatingProvinceUserId === user.id ||
      disablingUserId === user.id ||
      enablingUserId === user.id ||
      blockingUserId === user.id ||
      unblockingUserId === user.id
    }
    onChange={(event) =>
      handleUpdateUserProvince(
        user,
        event.target.value,
      )
    }
  >
    <option value="">
      غير محددة
    </option>

    {provincesList.map(
      (province) => (
        <option
  key={province.id}
  value={province.name.ar}
>
  {province.name.ar}
</option>
      ),
    )}
  </select>
</td>
<td className="accounts-address-cell">
  <span className="accounts-address-id">
    {formatDefaultAddress(user.defaultAddress)}
  </span>
</td>
<td>
  <button
    type="button"
    className="accounts-address-btn"
    onClick={() => handleOpenAddresses(user)}
    title="عرض عناوين المستخدم"
  >
    <FontAwesomeIcon icon={faMapMarkerAlt} />
    <span>العناوين</span>
  </button>
</td>
                <td className="accounts-date-cell">
                  {formatCreatedAt(user.createdAt)}
                </td>

                <td>
                  <div className="accounts-actions">
                    <button
                      type="button"
                      className="accounts-action-btn accounts-view-btn"
                      onClick={() => handleViewAccount(user)}
                      title="عرض بيانات الحساب"
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                    {user.isBlocked ||
user.status === "blocked" ? (
  <button
    type="button"
    className="accounts-action-btn accounts-unblock-btn"
    onClick={() =>
      handleUnblockUser(user)
    }
    disabled={
      unblockingUserId === user.id ||
      user.authDisabled ||
      user.status === "disabled"
    }
    title="إلغاء حظر المستخدم"
  >
    {unblockingUserId === user.id
      ? "..."
      : "إلغاء الحظر"}
  </button>
) : (
  <button
    type="button"
    className="accounts-action-btn accounts-block-btn"
    onClick={() =>
      handleOpenBlockModal(user)
    }
    disabled={
      blockingUserId === user.id ||
      user.authDisabled ||
      user.status === "disabled"
    }
    title={
      user.authDisabled ||
      user.status === "disabled"
        ? "الحساب معطل"
        : "حظر المستخدم"
    }
  >
    حظر
  </button>
)}

<button
  type="button"
  className="accounts-action-btn accounts-email-login-btn"
  onClick={() =>
    handleOpenEmailLoginModal(
      user,
    )
  }
  disabled={
    savingEmailLogin &&
    selectedEmailLoginUser?.id ===
      user.id
  }
  title={
    user.email
      ? "تعديل تسجيل الدخول بالإيميل"
      : "إضافة تسجيل دخول بالإيميل"
  }
>
  <FontAwesomeIcon
    icon={faEnvelope}
  />
</button>
                    <button
                      type="button"
                      className="accounts-action-btn accounts-edit-btn"
                      onClick={() => handleEdit(user.id)}
                      title="تعديل"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>

           {user.authDisabled ||
user.status === "disabled" ? (
  <button
    type="button"
    className="accounts-action-btn accounts-enable-btn"
    onClick={() =>
      handleEnableUser(user)
    }
    disabled={
      enablingUserId === user.id
    }
    title="إعادة تفعيل الحساب"
  >
    {enablingUserId === user.id
      ? "..."
      : "تفعيل"}
  </button>
) : (
  <button
    type="button"
    className="accounts-action-btn accounts-delete-btn"
    onClick={() =>
      handleOpenModal(user.id)
    }
    disabled={
      disablingUserId === user.id
    }
    title="تعطيل الحساب"
  >
    <FontAwesomeIcon icon={faTrash} />
  </button>
)}
                    <button
  type="button"
  className="accounts-action-btn accounts-question-btn"
  onClick={() => handleOpenQuestionsModal(user)}
  title="أسئلة متابعة التطبيق"
>
  <FontAwesomeIcon icon={faClipboardQuestion} />
</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

       {displayedProducts.length === 0 && (
          <div className="accounts-empty-state">
  {debouncedSearchQuery ||
  accountTypeFilter ||
  provinceFilter
    ? "لا توجد حسابات مطابقة للبحث أو الفلاتر."
    : "لا توجد حسابات لعرضها."}
</div>
        )}
      </div>

      
    )}

<div className="accounts-pagination-section">
  {usersPagination.hasMore &&
    usersPagination.nextCursor && (
      <button
        type="button"
        className="accounts-load-more-btn"
        onClick={
          handleLoadMore
        }
        disabled={loadingMore}
      >
        {loadingMore
          ? "جاري تحميل المزيد..."
          : "تحميل المزيد"}
      </button>
    )}
</div>
 <Modal
  open={openModal}
  onClose={handleCloseModal}
  className="accounts-modal"
>
  <Box
    className="accounts-modal-card"
    dir="rtl"
  >
    <Typography className="accounts-modal-title">
      تعطيل حساب المستخدم
    </Typography>

    <p className="accounts-modal-description">
      سيتم منع المستخدم من تسجيل الدخول،
      مع الاحتفاظ بجميع بياناته وطلباته
      وعناوينه داخل النظام.
    </p>

    <div className="accounts-disable-reason-field">
      <label>
        سبب التعطيل
      </label>

      <textarea
        value={disableReason}
        onChange={(event) =>
          setDisableReason(
            event.target.value,
          )
        }
        rows={3}
        maxLength={500}
        disabled={Boolean(
          disablingUserId,
        )}
        placeholder="مثال: طلب المستخدم إيقاف الحساب أو مخالفة شروط الاستخدام"
      />

      <small>
        {disableReason.length}/500
      </small>
    </div>

    <Box className="accounts-modal-actions">
      <Button
        className="accounts-modal-delete-btn"
        onClick={handleDisableUser}
        disabled={Boolean(
          disablingUserId,
        )}
      >
        {disablingUserId
          ? "جاري تعطيل الحساب..."
          : "نعم، عطّل الحساب"}
      </Button>

      <Button
        className="accounts-modal-cancel-btn"
        onClick={handleCloseModal}
        disabled={Boolean(
          disablingUserId,
        )}
      >
        إلغاء
      </Button>
    </Box>
  </Box>
</Modal>
<Modal
  open={addressesModalOpen}
  onClose={handleCloseAddressesModal}
  className="accounts-modal"
>
  <Box className="accounts-addresses-modal-card">
    <Typography className="accounts-modal-title">
      عناوين المستخدم
    </Typography>

    {selectedAddressUser && (
      <div className="accounts-addresses-user">
        {selectedAddressUser.fullName || "مستخدم بدون اسم"}
      </div>
    )}

    {addressesLoading ? (
      <div className="accounts-addresses-loading">
        جاري تحميل العناوين...
      </div>
    ) : userAddresses.length === 0 ? (
      <div className="accounts-addresses-empty">
        هذا المستخدم لا يحتوي على أي عنوان
      </div>
    ) : (
      <div className="accounts-addresses-list">
  {userAddresses.map((address) => {
  const addressText =
    buildAddressText(address);

  return (
    <button
      key={address.addressId}
      type="button"
      className="accounts-address-card"
      onClick={() => handleSetDefaultAddress(address)}
    >
      <div className="accounts-address-card-header">
        <span>{address.addressName || "عنوان بدون اسم"}</span>
        <small>{address.province || "بدون محافظة"}</small>
      </div>

      <div className="accounts-address-card-body">
        <p className="accounts-address-full-text">
  {addressText || "لا توجد تفاصيل إضافية للعنوان"}
</p>
        <p>
          <strong>المدينة:</strong>{" "}
          {address.City || "غير محددة"}
        </p>

        <p>
          <strong>المنطقة / البوابة:</strong>{" "}
          {address.gate || "غير محددة"}
        </p>

        <p>
          <strong>رقم الهاتف:</strong>{" "}
          {address.phoneNumber || "غير متوفر"}
        </p>

        <p>
          <strong>اسم الموقع:</strong>{" "}
          {address.locationName || "غير متوفر"}
        </p>

        {address.additionalInfo && (
          <p>
            <strong>معلومات إضافية:</strong>{" "}
            {address.additionalInfo}
          </p>
        )}

        <p className="accounts-address-save-preview">
          سيتم حفظ ID هذا العنوان كعنوان افتراضي: {address.addressId}
        </p>
      </div>
    </button>
  );
})}
      </div>
    )}

    <Box className="accounts-modal-actions">
      <Button
        className="accounts-modal-cancel-btn"
        onClick={handleCloseAddressesModal}
      >
        إغلاق
      </Button>
    </Box>
  </Box>
</Modal>

<Modal
  open={questionsModalOpen}
  onClose={handleCloseQuestionsModal}
  className="accounts-modal"
>
  <Box className="accounts-questions-modal-card">
    <Typography className="accounts-modal-title">
      أسئلة متابعة التطبيق
    </Typography>

    {selectedQuestionUser && (
      <div className="accounts-questions-user">
        <span>الحساب:</span>
        <strong>{selectedQuestionUser.fullName || "مستخدم بدون اسم"}</strong>
      </div>
    )}

    <div className="accounts-questions-list">
      <div className="accounts-question-item">
        <label>هل قدمت طلب من خلال التطبيق لتحويل حسابك الى تقني؟</label>
        <select
          value={appQuestionForm.technicianRequest}
          onChange={(e) => handleQuestionChange("technicianRequest", e.target.value)}
        >
          <option value="">اختر الإجابة</option>
          <option value="yes">نعم</option>
          <option value="no">لا</option>
        </select>
      </div>

      <div className="accounts-question-item">
        <label>هل قمت بقراءة السيريلات من خلال التطبيق؟</label>
        <select
          value={appQuestionForm.serialsRead}
          onChange={(e) => handleQuestionChange("serialsRead", e.target.value)}
        >
          <option value="">اختر الإجابة</option>
          <option value="yes">نعم</option>
          <option value="no">لا</option>
        </select>
      </div>

      <div className="accounts-question-item">
        <label>هل لديك ملاحظات حول التطبيق؟</label>
        <select
          value={appQuestionForm.hasAppNotes}
          onChange={(e) => handleQuestionChange("hasAppNotes", e.target.value)}
        >
          <option value="">اختر الإجابة</option>
          <option value="yes">نعم</option>
          <option value="no">لا</option>
        </select>
      </div>

      <div className="accounts-question-item">
        <label>هل تحتاج الى معلومة حول التطبيق؟</label>
        <select
          value={appQuestionForm.needsAppInfo}
          onChange={(e) => handleQuestionChange("needsAppInfo", e.target.value)}
        >
          <option value="">اختر الإجابة</option>
          <option value="yes">نعم</option>
          <option value="no">لا</option>
        </select>
      </div>

      <div className="accounts-question-item">
        <label>هل قمت بإضافة عنوان افتراضي لك؟</label>
        <select
          value={appQuestionForm.hasDefaultAddress}
          onChange={(e) => handleQuestionChange("hasDefaultAddress", e.target.value)}
        >
          <option value="">اختر الإجابة</option>
          <option value="yes">نعم</option>
          <option value="no">لا</option>
        </select>
      </div>

      <div className="accounts-question-item">
        <label>ما هو تقييمك من ٥ درجات للتطبيق؟</label>
        <select
          value={appQuestionForm.appRating}
          onChange={(e) => handleQuestionChange("appRating", e.target.value)}
        >
          <option value="">اختر التقييم</option>
          <option value="1">1 من 5</option>
          <option value="2">2 من 5</option>
          <option value="3">3 من 5</option>
          <option value="4">4 من 5</option>
          <option value="5">5 من 5</option>
        </select>
      </div>

      <div className="accounts-question-item accounts-question-notes">
        <label>الملاحظات</label>
        <textarea
          value={appQuestionForm.notes}
          onChange={(e) => handleQuestionChange("notes", e.target.value)}
          placeholder="اكتب أي ملاحظات إضافية هنا..."
          rows={4}
        />
      </div>
    </div>

    <Box className="accounts-modal-actions">
      <Button
        className="accounts-modal-confirm-btn"
        onClick={handleSaveAppQuestions}
        disabled={savingQuestions}
      >
        {savingQuestions ? "جاري الحفظ..." : "حفظ"}
      </Button>

      <Button
        className="accounts-modal-cancel-btn"
        onClick={handleCloseQuestionsModal}
        disabled={savingQuestions}
      >
        إلغاء
      </Button>
    </Box>
  </Box>
</Modal>

<Modal
  open={createAccountModalOpen}
  onClose={handleCloseCreateAccountModal}
  className="accounts-modal"
>
  <Box className="accounts-create-modal-card">
    <div className="accounts-create-modal-header">
      <div className="accounts-create-modal-icon">
        <FontAwesomeIcon icon={faUserPlus} />
      </div>

      <div>
        <Typography className="accounts-create-modal-title">
          إنشاء حساب جديد
        </Typography>

        <p>
          سيتم إنشاء الحساب في Firebase Authentication
          وحفظ بياناته في Firestore.
        </p>
      </div>
    </div>

    <div className="accounts-create-form">
      <div className="accounts-create-field accounts-create-field-full">
        <label>
          الاسم الكامل
          <span>*</span>
        </label>

        <input
          type="text"
          value={createAccountForm.fullName}
          onChange={(event) =>
            handleCreateAccountChange(
              "fullName",
              event.target.value
            )
          }
          placeholder="أدخل الاسم الكامل"
          disabled={creatingAccount}
        />
      </div>

      <div className="accounts-create-field">
        <label>
          البريد الإلكتروني
          <span>*</span>
        </label>

        <input
          type="email"
          value={createAccountForm.email}
          onChange={(event) =>
            handleCreateAccountChange(
              "email",
              event.target.value
            )
          }
          placeholder="example@email.com"
          dir="ltr"
          disabled={creatingAccount}
        />
      </div>

      <div className="accounts-create-field">
        <label>رقم الهاتف</label>

        <input
          type="text"
          value={createAccountForm.phoneNumber}
          onChange={(event) =>
            handleCreateAccountChange(
              "phoneNumber",
              event.target.value
            )
          }
          placeholder="07xxxxxxxxx"
          dir="ltr"
          disabled={creatingAccount}
        />
      </div>

      <div className="accounts-create-field">
        <label>
          كلمة المرور
          <span>*</span>
        </label>

        <div className="accounts-create-password-wrapper">
          <input
            type={
              showCreatePassword
                ? "text"
                : "password"
            }
            value={createAccountForm.password}
            onChange={(event) =>
              handleCreateAccountChange(
                "password",
                event.target.value
              )
            }
            placeholder="6 أحرف على الأقل"
            dir="ltr"
            disabled={creatingAccount}
          />

          <button
            type="button"
            onClick={() =>
              setShowCreatePassword(
                (previous) => !previous
              )
            }
            disabled={creatingAccount}
          >
            {showCreatePassword ? "إخفاء" : "إظهار"}
          </button>
        </div>
      </div>

      <div className="accounts-create-field">
        <label>
          تأكيد كلمة المرور
          <span>*</span>
        </label>

        <input
          type={
            showCreatePassword
              ? "text"
              : "password"
          }
          value={createAccountForm.confirmPassword}
          onChange={(event) =>
            handleCreateAccountChange(
              "confirmPassword",
              event.target.value
            )
          }
          placeholder="أعد كتابة كلمة المرور"
          dir="ltr"
          disabled={creatingAccount}
        />
      </div>

      <div className="accounts-create-field">
        <label>
          نوع الحساب
          <span>*</span>
        </label>

    <AccountTypeSelect
  id="create-account-type"
  value={createAccountForm.accountType}
  includeAllOption={false}
  disabled={creatingAccount}
  onChange={(value) => {
    handleCreateAccountChange(
      "accountType",
      value,
    );

    const availableLevels =
      getAccountLevels(value);

    if (
      !availableLevels.includes(
        createAccountForm.AccountLevel,
      )
    ) {
      handleCreateAccountChange(
        "AccountLevel",
        "",
      );
    }
  }}
/>
      </div>

      <div className="accounts-create-field">
        <label>المحافظة</label>

        <select
          value={createAccountForm.province}
          onChange={(event) =>
            handleCreateAccountChange(
              "province",
              event.target.value
            )
          }
          disabled={creatingAccount}
        >
          <option value="">
            بدون محافظة
          </option>

          {provincesList.map((province) => (
            <option
              key={province.id}
              value={province.id}
            >
              {province.name?.ar ||
                province.name?.en ||
                province.id}
            </option>
          ))}
        </select>
      </div>

    <div className="accounts-create-field accounts-create-field-full">
  <label>مستوى الحساب</label>

  {getAccountLevels(
    createAccountForm.accountType,
  ).length > 0 ? (
    <select
      value={
        createAccountForm.AccountLevel
      }
      onChange={(event) =>
        handleCreateAccountChange(
          "AccountLevel",
          event.target.value,
        )
      }
      disabled={creatingAccount}
    >
      <option value="">
        اختر مستوى الحساب
      </option>

      {getAccountLevels(
        createAccountForm.accountType,
      ).map((level) => (
        <option
          key={level}
          value={level}
        >
          {level}
        </option>
      ))}
    </select>
  ) : (
    <input
      type="text"
      value=""
      placeholder="نوع الحساب المحدد لا يحتاج مستوى"
      disabled
    />
  )}
</div>
    </div>

    <div className="accounts-create-notice">
      كلمة المرور ستُحفظ في Firebase Authentication فقط،
      ولن يتم تخزينها داخل Firestore.
    </div>

    <Box className="accounts-modal-actions accounts-create-modal-actions">
      <Button
        className="accounts-modal-confirm-btn"
        onClick={handleCreateAccount}
        disabled={creatingAccount}
      >
        {creatingAccount
          ? "جاري إنشاء الحساب..."
          : "إنشاء الحساب"}
      </Button>

      <Button
        className="accounts-modal-cancel-btn"
        onClick={handleCloseCreateAccountModal}
        disabled={creatingAccount}
      >
        إلغاء
      </Button>
    </Box>
  </Box>
</Modal>

<Modal
  open={emailLoginModalOpen}
  onClose={
    handleCloseEmailLoginModal
  }
  className="accounts-modal"
>
  <Box
    className="accounts-email-login-modal-card"
    dir="rtl"
  >
    <div className="accounts-email-login-header">
      <div className="accounts-email-login-icon">
        <FontAwesomeIcon
          icon={faEnvelope}
        />
      </div>

      <div>
        <Typography className="accounts-email-login-title">
          إعداد تسجيل الدخول بالإيميل
        </Typography>

        <p>
          سيتم ربط البريد الإلكتروني وكلمة المرور
          بنفس حساب المستخدم الحالي بدون إنشاء حساب جديد.
        </p>
      </div>
    </div>

    {selectedEmailLoginUser && (
      <div className="accounts-email-login-user">
        <span>
          المستخدم
        </span>

        <strong>
          {selectedEmailLoginUser.fullName ||
            selectedEmailLoginUser.phoneNumber ||
            selectedEmailLoginUser.id}
        </strong>

        <small>
          UID:{" "}
          {selectedEmailLoginUser.id}
        </small>
      </div>
    )}

    <div className="accounts-email-login-form">
      <div className="accounts-email-login-field">
        <label>
          البريد الإلكتروني
          <span>*</span>
        </label>

        <input
          type="email"
          dir="ltr"
          value={
            emailLoginForm.email
          }
          onChange={(event) =>
            handleEmailLoginFormChange(
              "email",
              event.target.value,
            )
          }
          placeholder="user@example.com"
          disabled={
            savingEmailLogin
          }
        />
      </div>

      <div className="accounts-email-login-field">
        <label>
          كلمة المرور
          <span>*</span>
        </label>

        <div className="accounts-email-login-password-wrapper">
          <input
            type={
              showEmailLoginPassword
                ? "text"
                : "password"
            }
            dir="ltr"
            value={
              emailLoginForm.password
            }
            onChange={(event) =>
              handleEmailLoginFormChange(
                "password",
                event.target.value,
              )
            }
            placeholder="6 أحرف على الأقل"
            disabled={
              savingEmailLogin
            }
          />

          <button
            type="button"
            onClick={() =>
              setShowEmailLoginPassword(
                (previous) =>
                  !previous,
              )
            }
            disabled={
              savingEmailLogin
            }
          >
            {showEmailLoginPassword
              ? "إخفاء"
              : "إظهار"}
          </button>
        </div>
      </div>

      <div className="accounts-email-login-field">
        <label>
          تأكيد كلمة المرور
          <span>*</span>
        </label>

        <input
          type={
            showEmailLoginPassword
              ? "text"
              : "password"
          }
          dir="ltr"
          value={
            emailLoginForm.confirmPassword
          }
          onChange={(event) =>
            handleEmailLoginFormChange(
              "confirmPassword",
              event.target.value,
            )
          }
          placeholder="أعد كتابة كلمة المرور"
          disabled={
            savingEmailLogin
          }
        />
      </div>

      <label className="accounts-email-login-checkbox">
        <input
          type="checkbox"
          checked={
            emailLoginForm.emailVerified
          }
          onChange={(event) =>
            handleEmailLoginFormChange(
              "emailVerified",
              event.target.checked,
            )
          }
          disabled={
            savingEmailLogin
          }
        />

        <div>
          <strong>
            اعتبار البريد الإلكتروني موثقًا
          </strong>

          <small>
            فعّل هذا الخيار فقط إذا كنت متأكدًا من أن البريد يعود للمستخدم.
          </small>
        </div>
      </label>
    </div>

    <div className="accounts-email-login-notice">
      <strong>
        لن يتم إنشاء مستخدم جديد.
      </strong>

      <span>
        سيتم الاحتفاظ بنفس UID ورقم الهاتف والطلبات
        والنقاط وجميع بيانات الحساب الحالية.
        كلمة المرور تحفظ داخل Firebase Authentication فقط.
      </span>
    </div>

    <Box className="accounts-modal-actions accounts-email-login-actions">
      <Button
        className="accounts-modal-confirm-btn"
        onClick={
          handleSaveEmailLogin
        }
        disabled={
          savingEmailLogin
        }
      >
        {savingEmailLogin
          ? "جاري حفظ بيانات الدخول..."
          : "حفظ تسجيل الدخول"}
      </Button>

      <Button
        className="accounts-modal-cancel-btn"
        onClick={
          handleCloseEmailLoginModal
        }
        disabled={
          savingEmailLogin
        }
      >
        إلغاء
      </Button>
    </Box>
  </Box>
</Modal>

    <AccountDetails
      open={accountDetailsOpen}
      onClose={handleCloseAccountDetails}
      account={selectedAccountDetails}
    />


    {accountChangeModalOpen &&
  accountChangeUser && (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 px-4"
      dir="rtl"
    >
      <div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
        <div className="mb-5">
          <h2 className="font-custom text-xl font-bold text-gray-900">
            تأكيد تغيير نوع الحساب
          </h2>

          <p className="mt-2 font-custom text-sm text-gray-600">
            المستخدم:{" "}
            <strong>
              {accountChangeUser.fullName ||
                accountChangeUser.phoneNumber ||
                accountChangeUser.id}
            </strong>
          </p>
        </div>

        <div className="space-y-4">
          <div className="rounded-xl bg-gray-50 p-4">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              <div>
                <span className="block font-custom text-xs text-gray-500">
                  نوع الحساب الحالي
                </span>

                <strong className="font-custom text-gray-900">
                  {accountChangeUser.accountType ||
                    "غير محدد"}
                </strong>
              </div>

              <div>
                <span className="block font-custom text-xs text-gray-500">
                  نوع الحساب الجديد
                </span>

                <strong className="font-custom text-cyan-700">
                  {pendingAccountType}
                </strong>
              </div>
            </div>
          </div>

          {getAccountLevels(
            pendingAccountType,
          ).length > 0 && (
            <div>
              <label className="mb-2 block font-custom text-sm font-semibold text-gray-700">
                مستوى الحساب
              </label>

              <select
                value={pendingAccountLevel}
                onChange={(event) =>
                  setPendingAccountLevel(
                    event.target.value,
                  )
                }
                disabled={Boolean(
                  updatingAccountUserId,
                )}
                className="w-full rounded-xl border border-gray-300 bg-white p-3 font-custom focus:border-cyan-600 focus:outline-none focus:ring-2 focus:ring-cyan-200"
              >
                <option value="">
                  اختر مستوى الحساب
                </option>

                {getAccountLevels(
                  pendingAccountType,
                ).map((level) => (
                  <option
                    key={level}
                    value={level}
                  >
                    {level}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div>
            <label className="mb-2 block font-custom text-sm font-semibold text-gray-700">
              سبب التغيير
            </label>

            <textarea
              value={accountChangeReason}
              onChange={(event) =>
                setAccountChangeReason(
                  event.target.value,
                )
              }
              disabled={Boolean(
                updatingAccountUserId,
              )}
              rows={3}
              maxLength={500}
              placeholder="مثال: تمت الموافقة على طلب ترقية الحساب"
              className="w-full resize-none rounded-xl border border-gray-300 bg-white p-3 font-custom focus:border-cyan-600 focus:outline-none focus:ring-2 focus:ring-cyan-200"
            />

            <div className="mt-1 text-left font-custom text-xs text-gray-500">
              {
                accountChangeReason.length
              }
              /500
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={
              handleCloseAccountChange
            }
            disabled={Boolean(
              updatingAccountUserId,
            )}
            className="rounded-xl bg-gray-200 px-5 py-3 font-custom font-semibold text-gray-800 transition hover:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-60"
          >
            إلغاء
          </button>

          <button
            type="button"
            onClick={
              handleConfirmAccountChange
            }
            disabled={Boolean(
              updatingAccountUserId,
            )}
            className="rounded-xl bg-[#262d34] px-5 py-3 font-custom font-semibold text-white transition hover:bg-[#374151] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {updatingAccountUserId
              ? "جاري تحديث الحساب..."
              : "تأكيد التغيير"}
          </button>
        </div>
      </div>
    </div>
  )}


  <Modal
  open={blockModalOpen}
  onClose={handleCloseBlockModal}
  className="accounts-modal"
>
  <Box
    className="accounts-modal-card"
    dir="rtl"
  >
    <Typography className="accounts-modal-title">
      حظر المستخدم
    </Typography>

    {selectedBlockUser && (
      <p className="accounts-modal-description">
        سيتم حظر المستخدم:{" "}
        <strong>
          {selectedBlockUser.fullName ||
            selectedBlockUser.phoneNumber ||
            selectedBlockUser.id}
        </strong>
      </p>
    )}

    <div className="accounts-disable-reason-field">
      <label>
        سبب الحظر
      </label>

      <textarea
        value={blockReason}
        onChange={(event) =>
          setBlockReason(
            event.target.value,
          )
        }
        rows={3}
        maxLength={500}
        disabled={Boolean(
          blockingUserId,
        )}
        placeholder="اكتب سبب حظر المستخدم"
      />

      <small>
        {blockReason.length}/500
      </small>
    </div>

    <Box className="accounts-modal-actions">
      <Button
        className="accounts-modal-delete-btn"
        onClick={handleBlockUser}
        disabled={Boolean(
          blockingUserId,
        )}
      >
        {blockingUserId
          ? "جاري حظر المستخدم..."
          : "تأكيد الحظر"}
      </Button>

      <Button
        className="accounts-modal-cancel-btn"
        onClick={handleCloseBlockModal}
        disabled={Boolean(
          blockingUserId,
        )}
      >
        إلغاء
      </Button>
    </Box>
  </Box>
</Modal>
  </div>
);

};

export default Account;
